import React from "react"
import { useAlgoliaSearchState } from "../../controller/state"
import ProductCategoryTreeFilter from "../ProductCategoryTreeFilter"

const ProductCategoryRoot = () => {
  const {
    uiFilters,
    updateSearchParams,
    searchParams,
  } = useAlgoliaSearchState()

  const tree = uiFilters?.categories
  if (!tree?.root || tree.root.length <= 1) {
    return <></>
  }

  return (
    <ProductCategoryTreeFilter
      updateSearchParams={updateSearchParams}
      tree={tree}
      searchParams={searchParams}
    />
  )
}

export default ProductCategoryRoot
